var $ = require('../../modules/$');
module.exports = function create(P, D){
  return $.create(P, D);
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/create.js
// module id = oM7Q
// module chunks = 0